import axiosInstance from '@/utils/api.js'

var state = {
  otherCharges: []
}

var getters = {

  OTHER_CHARGES: (state) => {
    return state.otherCharges
  }
}

var mutations = {
  SET_OTHER_CHARGES: (state, payload) => {
    state.otherCharges = payload
  }
}

var actions = {
  GET_OTHER_CHARGES: async (context, payload) => {
    let result = await axiosInstance.get('/reports/other_charges?start=' + payload.numDateStart +
    '&end=' + payload.numDateEnd +
    '&user_id=' + payload.userId +
    '&group_id=' + payload.group_id +
    '&accs_group_id=' + payload.accs_group_id +
    '&accounting_period_id=0&account_id=0' +
    '&limit=' + payload.limit +
    '&download=' + payload.download, {timeout: 45000})
    if (result.status === 200) {
      context.commit('SET_OTHER_CHARGES', result.data)
    }
  },
  CLEAR_OTHER_CHARGES: (context) => {
    context.commit('SET_OTHER_CHARGES', [])
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/reports/otherCharges.js